'use strict';
import { InjectableClass } from '@fino/lib-injection';

export class StandingOrdersConflictModalService extends InjectableClass {
  constructor(uiModalDeclarationService) {
    'ngInject';
    super({
      uiModalDeclarationService,
    });
  }

  openModal(data, ticketData) {
    this.modal = this.uiModalDeclarationService.$uibModal.open({
      component: 'standingOrderConflictModalComponent',
      resolve: {
        conflictData: () => data,
        ticketData: () => ticketData,
      },
      size: 'lg',
    });
    return this.modal;
  }

  closeModal(approve = false) {
    if (this.modal) {
      this.modal.close(approve);
    }
  }
}
